"use strict";
import gsap from "gsap";



// nav ////////////////////////////////////////

const menuToggle = document.querySelector('.menu-toggle');
const menuLinks  = document.querySelectorAll('.menu__link');

menuToggle.addEventListener('click', menuOpen );

function menuOpen(){
    document.body.classList.toggle("menu--open");
}
menuLinks.forEach(link => {
  link.addEventListener('click', () => {
    document.body.classList.remove("menu--open");
  });
});


////////////////////////////////////// cursor custom
  
const cursor = document.querySelector('.custom-cursor');

// Bouge le curseur avec la souris
document.addEventListener('mousemove', (e) => {
  cursor.style.top = e.clientY + 'px';
  cursor.style.left = e.clientX + 'px';
});

// Quand on survole un élément interactif
const interactives = document.querySelectorAll('a, button, .cursor-hover');

interactives.forEach((el) => {
  el.addEventListener('mouseenter', () => {
    cursor.classList.add('hover');
  });
  el.addEventListener('mouseleave', () => {
    cursor.classList.remove('hover');
  });
});
  
  
  
/////////////////////annee du footer
var actualyear = new Date().getFullYear();
var footerYear = document.querySelector(".footer__year");
footerYear.textContent = "© " + actualyear + " DUCARNE Julie";






const IndexAccueil = document.querySelector(".accueil");

if (IndexAccueil) {

  // animation header hello
  const title = document.getElementById('split-title');
  const words = title.textContent.trim().split(' ');
  
  title.textContent = '';
  
  let count = 0; // compteur global
  
  words.forEach((word, index) => {
    const wordWrapper = document.createElement('span');
    wordWrapper.style.display = 'inline-block';
  
    // lettres animées
    [...word].forEach(char => {
      const span = document.createElement('span');
      span.textContent = char;
      span.style.animationDelay = `${count * 0.05}s`;
      count++;
      wordWrapper.appendChild(span);
    });
  
    title.appendChild(wordWrapper);
  
    //Ajoute un espace normal après le mot, sauf après le dernier
    if (index < words.length - 1) {
      title.appendChild(document.createTextNode('\u00A0'));
    }
  });
  
  /////////////// le mousehover du bg header 
  particlesJS("particles-js", {
    "particles": {
      "number": {
        "value": 100,
        "density": {
          "enable": true,
          "value_area":1000
        }
      },
      "color": {
        "value": ["#aa73ff", "#f8c210", "#83d238", "#33b1f8"]
      },
      
      "shape": {
        "type": "circle",
        "stroke": {
          "width": 0,
          "color": "#fff"
        },
        "polygon": {
          "nb_sides": 5
        },
        "image": {
          "src": "img/github.svg",
          "width": 100,
          "height": 100
        }
      },
      "opacity": {
        "value": 0.6,
        "random": false,
        "anim": {
          "enable": false,
          "speed": 1,
          "opacity_min": 0.1,
          "sync": false
        }
      },
      "size": {
        "value": 2,
        "random": true,
        "anim": {
          "enable": false,
          "speed": 40,
          "size_min": 0.1,
          "sync": false
        }
      },
      "line_linked": {
        "enable": true,
        "distance": 120,
        "color": "#ffffff",
        "opacity": 0.4,
        "width": 1
      },
    },
    "interactivity": {
      "detect_on": "canvas",
      "events": {
        "onhover": {
          "enable": true,
          "mode": "grab"
        },
        "onclick": {
          "enable": false
        },
        "resize": true
      },
      "modes": {
        "grab": {
          "distance": 140,
          "line_linked": {
            "opacity": 1
          }
        },
        "bubble": {
          "distance": 400,
          "size": 40,
          "duration": 2,
          "opacity": 8,
          "speed": 3
        },
        "repulse": {
          "distance": 200,
          "duration": 0.4
        },
        "push": {
          "particles_nb": 4
        },
        "remove": {
          "particles_nb": 2
        }
      }
    },
    "retina_detect": true
  });
  

  
  
  ////////////////////// le scroll des projets 
  gsap.registerPlugin(ScrollTrigger);
  
  ScrollTrigger.matchMedia({
  
    "(min-width: 879px)": function() {
  
      document.querySelectorAll(".parallax").forEach(el => {
          el.classList.remove("floating");
      });
  
      gsap.utils.toArray(".parallax").forEach(el => {
        const speed = parseFloat(el.getAttribute("data-speed"));
  
        gsap.to(el, {
          y: () => -(window.innerHeight * speed),
          ease: "none",
          scrollTrigger: {
            trigger: el,
            start: "bottom bottom", // quand l'élément entre dans la vue
            scrub: true
          }
        });
      });
  
    }
  
  });
  
  
  
  ////////////////////// les particules du main
  const containerPb = document.querySelector('.containerpb');
  const PARTICLE_COUNT_PB = 500;
  
  for (let iPb = 0; iPb < PARTICLE_COUNT_PB; iPb++) {
    const circlePb = document.createElement('div');
    circlePb.classList.add('circle-pb');
  
    // Taille aléatoire
    const sizePb = Math.random() * 5 + 2; // 2px à 7px
    circlePb.style.width = `${sizePb}px`;
    circlePb.style.height = `${sizePb}px`;
  
    // Position aléatoire
    const leftPb = Math.random() * 100;
    const topPb = Math.random() * 100;
    circlePb.style.left = `${leftPb}vw`;
    circlePb.style.top = `${topPb}vh`;
  
    // Durée et délai aléatoire
    const durationPb = Math.random() * 20 + 5; // 5s à 25s
    const delayPb = Math.random() * 20;
    circlePb.style.animationDuration = `${durationPb}s`;
    circlePb.style.animationDelay = `${delayPb}s`;
  
    containerPb.appendChild(circlePb);
  }
  
  
  ///////////////////// loop logo
  gsap.registerPlugin(); // pas d'argument -> aucun plugin supplémentaire
  
  const scrollingIcons = gsap.utils.toArray('.loop__rail i');
  
  const tll = horizontalLoop(scrollingIcons, {
    repeat: -1,
    paddingRight: 150,
    speed: 1
  });
  
  // ---------------------------------------------------
  // 4) Fonction utilitaire inchangée, juste recopiée telle quelle
  function horizontalLoop(items, config) {
    items = gsap.utils.toArray(items);
    config = config || {};
  
    let tll = gsap.timeline({
        repeat: config.repeat,
        paused: config.paused,
        defaults: { ease: "none" },
        onReverseComplete: () => tll.totalTime(tll.rawTime() + tll.duration() * 100)
      }),
      length = items.length,
      startX = items[0].offsetLeft,
      times = [],
      widths = [],
      xPercents = [],
      curIndex = 0,
      pixelsPerSecond = (config.speed || 1) * 100,
      snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1),
      totalWidth, curX, distanceToStart, distanceToLoop, item, i;
  
    gsap.set(items, {
      xPercent: (i, el) => {
        let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
        xPercents[i] = snap(
          parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 +
          gsap.getProperty(el, "xPercent")
        );
        return xPercents[i];
      }
    });
  
    gsap.set(items, { x: 0 });
  
    totalWidth = items[length - 1].offsetLeft +
                 xPercents[length - 1] / 100 * widths[length - 1] -
                 startX +
                 items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], "scaleX") +
                 (parseFloat(config.paddingRight) || 0);
  
    for (i = 0; i < length; i++) {
      item = items[i];
      curX = xPercents[i] / 100 * widths[i];
      distanceToStart = item.offsetLeft + curX - startX;
      distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
      tll.to(item, {
        xPercent: snap((curX - distanceToLoop) / widths[i] * 100),
        duration: distanceToLoop / pixelsPerSecond
      }, 0)
        .fromTo(item,
          { xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100) },
          {
            xPercent: xPercents[i],
            duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
            immediateRender: false
          },
          distanceToLoop / pixelsPerSecond
        )
        .add("label" + i, distanceToStart / pixelsPerSecond);
      times[i] = distanceToStart / pixelsPerSecond;
    }
  
    function toIndex(index, vars) {
      vars = vars || {};
      (Math.abs(index - curIndex) > length / 2) &&
        (index += index > curIndex ? -length : length);
      let newIndex = gsap.utils.wrap(0, length, index),
          time = times[newIndex];
      if (time > tll.time() !== index > curIndex) {
        vars.modifiers = { time: gsap.utils.wrap(0, tll.duration()) };
        time += tll.duration() * (index > curIndex ? 1 : -1);
      }
      curIndex = newIndex;
      vars.overwrite = true;
      return tll.tweenTo(time, vars);
    }
  
    tll.next = vars => toIndex(curIndex + 1, vars);
    tll.previous = vars => toIndex(curIndex - 1, vars);
    tll.current = () => curIndex;
    tll.toIndex = (index, vars) => toIndex(index, vars);
    tll.times = times;
    tll.progress(1, true).progress(0, true);
  
    if (config.reversed) {
      tll.vars.onReverseComplete();
      tll.reverse();
    }
    return tll;
  }
  
  
  //////////////////////////// le count up
  gsap.registerPlugin(ScrollTrigger);
  
  document.querySelectorAll('.data__chiffre').forEach(el => {
    const endValuecu   = parseInt(el.dataset.target, 10);
    const isInfinitecu = el.dataset.infinite === "true";
  
    ScrollTrigger.create({
      trigger: el,
      start: "top bottom", // quand le haut de la div touche le bas de l’écran
      onEnter: () => {
        gsap.fromTo(el,
          { innerText: 0 },
          {
            innerText: endValuecu,
            duration: 2,
            ease: "power1.out",
            snap: { innerText: 1 },
            onComplete() {
              if (isInfinitecu) el.innerHTML = '<i class="fa-solid fa-infinity"></i>';
            }
          }
        );
      },
      once: true // ne le fait qu’une fois
    });
  });
}


const ContactPage = document.querySelector(".body__contact");

if (ContactPage) {

  const form = document.getElementById('contact-form');
  const objetSelect = document.getElementById('objet');
  const objetAutre = document.getElementById('objet-autre');

  objetSelect.addEventListener('change', () => {
  if (objetSelect.value === 'autre') {
      objetAutre.classList.remove('contact__input--hidden');
      objetAutre.required = true;
  } else {
      objetAutre.classList.add('contact__input--hidden');
      objetAutre.required = false;
      objetAutre.value = '';
  }
  });

  form.addEventListener('submit', (e) => {
  e.preventDefault(); // Empêche l'envoi tant que tout n'est pas validé
  let errors = [];

  // Vérifie prénom
  const prenom = form.querySelector('[name="prenom"]');
  if (!prenom.value.trim()) errors.push('Prénom');

  // Vérifie nom
  const nom = form.querySelector('[name="nom"]');
  if (!nom.value.trim()) errors.push('Nom');

  // Vérifie email
  const email = form.querySelector('[name="email"]');
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email.value.trim()) {
      errors.push('Email');
  } else if (!emailPattern.test(email.value)) {
      errors.push('Email (format invalide)');
  }

  // Vérifie objet
  if (!objetSelect.value) errors.push('Objet');

  // Vérifie objet-autre si visible
  if (!objetAutre.classList.contains('contact__input--hidden') && !objetAutre.value.trim()) {
      errors.push('Objet (champ autre)');
  }

  // Vérifie message
  const message = form.querySelector('[name="message"]');
  if (!message.value.trim()) errors.push('Message');

  if (errors.length > 0) {
      alert('Veuillez remplir correctement les champs suivants :\n- ' + errors.join('\n- '));
      return false;
  }

  // Si tout est ok, envoie le formulaire
  form.submit();
  });


}